// src/services/apiClient.ts

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000/api/v1';

export async function apiClient(
    endpoint: string, 
    options?: RequestInit
): Promise<any> {
    const url = `${API_BASE_URL}/${endpoint}`;
    
    const token = localStorage.getItem('authToken'); 

    const headers: HeadersInit = {
        'Content-Type': 'application/json',
        ...(token && { 'Authorization': `Bearer ${token}` }),
        ...options?.headers as HeadersInit,
    };

    const response = await fetch(url, {
        ...options,
        headers,
    });

    if (!response.ok) {
        // --- 👇 CORRECCIÓN AQUÍ 👇 ---
        // Si el error es 401 PERO estamos intentando hacer login, NO borramos el token ni lanzamos "Sesión expirada"
        // Simplemente lanzamos el error normal para que LoginPage lo muestre.
        if (response.status === 401 && !endpoint.includes('auth/login')) {
             localStorage.removeItem('authToken');
             localStorage.removeItem('userName');
             throw new Error("Sesión expirada o no autorizada.");
        }
        
        let errorBody;
        try {
            errorBody = await response.json();
        } catch {
            errorBody = { message: 'Error de red o del servidor desconocido.' };
        }
        
        // Devuelve el mensaje del backend (ej: "Contraseña incorrecta")
        throw new Error(errorBody.message || `Error ${response.status}: ${response.statusText}`);
    }

    if (response.status === 204) {
        return null;
    }

    return response.json();
}